import { mapState, mapActions } from 'vuex'

import Icon from '@/components/icon'

export default {
  components: {
    appIcon: Icon
  },
  computed: {
		...mapState('utils', ['widgets']),
		isSuccess () {
			return this.widgets.notification.type === 'success'
		},
		isError () {
			return this.widgets.notification.type === 'error'
		},
		isShow () {
			return this.widgets.notification.show
		},
		message () {
			return this.widgets.notification.message
		}
  },
  methods: {
    ...mapActions('utils', ['closeNotification'])
  }
}
